// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1ef6ca94] .has-price-error fieldset{border-color:#ff5252!important;border-width:2px!important}", ""]);
// Exports
module.exports = exports;
